import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Address from "./modules/address";
import AdvancedFilter from "./modules/advanced-filter";
import Brands from "./modules/brands";
import Jobs from "./modules/jobs";
import Menu from "./modules/menu";
import ServiceTypes from "./modules/service-types";
import TechAvailability from "./modules/tech-availability";
import PaymentGateway from "./modules/payment-gateway";
import Achievement from "./modules/achievement";
import PublicHolidays from "./modules/public-holidays";
import Weather from "./modules/weather";
import Audit from "./modules/audit";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    achievement: Achievement,
    address: Address,
    "advanced-filter": AdvancedFilter,
    brands: Brands,
    jobs: Jobs,
    menu: Menu,
    "payment-gateway": PaymentGateway,
    "service-types": ServiceTypes,
    "tech-availability": TechAvailability,
    "public-holidays": PublicHolidays,
    weather: Weather,
    audit: Audit,
  },
  plugins: [
    createPersistedState({
      paths: ["brands.data", "weather.data", "tech-availability.selectFilterValues", "audit.data"],
    }),
  ],
});

export default store;
